import React, { useEffect } from 'react';
import '../fulfillmentTiles.scss';
import { setErrorEvents } from '../../../analytics';

export const NonMajorApplianceAlert = () => {
  const message = 'This item does not qualify for Major Appliance Delivery and Haul Away or Installation Services.';

  useEffect(() => {
    setErrorEvents({ message });
  }, []);

  return (
    <div className="alert-inline alert-inline--warning inventory--warning-tiles">
      <div>
        <span>
          {message}
        </span>
      </div>
    </div>
  );
};